import { useState } from "react";
import { PawPrint } from "lucide-react";
import { mediaUrl } from "@/lib/api";

/** A product photo, or a soft paw placeholder when the item has no photo
 *  (or it fails to load), instead of the browser's broken-image icon. */
export default function ProductImage({ src, alt = "", className = "", iconClass = "h-1/3 w-1/3 max-h-12 max-w-12" }) {
  const [failed, setFailed] = useState(false);
  const url = mediaUrl(src);
  if (!url || failed) {
    return (
      <div role="img" aria-label={alt || "No photo"} data-testid="product-image-placeholder"
        className={`flex items-center justify-center bg-gradient-to-br from-stone-100 to-marigold/10 text-stone-300 ${className}`}>
        <PawPrint className={iconClass} />
      </div>
    );
  }
  return <img src={url} alt={alt} loading="lazy" onError={() => setFailed(true)} className={className} />;
}
